import { Link, Typography } from '@mui/material';
import * as React from 'react';

import { BOOKING_DATETIME_IS_WITHIN_RANGE, BOOKING_IS_REBOOKING, PHONE_COUNTRY, REVIEW_IS_POSITIVE_NEGATIVE, REVIEW_RATING, TOUR_PARTICIPANT_FIELD_EXISTS, TOUR_PARTICIPANT_HAS_TAG, TOUR_PARTICIPANT_HAS_TAG_CATEGORY, TOUR_PARTICIPANT_IS_FIELD_AFFECTED, TOUR_PARTICIPANT_IS_UPDATED_VIA, TOUR_PARTICIPANT_SURVEY_STATE, TRIP_BEGINS_WITHIN_X_TIME, USER_COUNTRY, USER_ENTERS_LOCATION_RADIUS, USER_HAS_OTHER_TOURS, USER_LANGUAGE, USER_LOGGED_IN, USER_REGISTERED_VIA_OTA, INCLUDE_RULESET, EVENT_TYPE, DATETIME_WITHIN_RANGE, DATE_WITHIN_RANGE, TIME_WITHIN_RANGE, DT_RANGE_COMPARISONS } from './utils';
import { effectiveTz, TZ_UTC } from './dtRangeBounds';

    const NotificationRuleDescription = (props) => {
    let sublabel = null;
    // TODO: add sublabel for each rule
    if (props.rule) {
        switch (props.rule.tpl) {
            case USER_LOGGED_IN:
                sublabel = +props.rule.args?.period > 0 ? `Within ${props.rule.args?.period} seconds` : 'At least once';
                break;
            case USER_COUNTRY:
                sublabel = `${props.rule.args?.country}`
                break;
            case PHONE_COUNTRY:
                sublabel = `${props.rule.args?.country}`
                break;
            case USER_LANGUAGE:
                sublabel = `${props.rule.args?.lang}`
                break;
            case USER_REGISTERED_VIA_OTA:
                const ota_label = props.rule.args?.ota?.length > 0 ?props.rule.args?.ota.map(x => x.name).join(', ') : 'Any OTA';
                const unique_emails = +props.rule.args?.unique_emails;
                const direct = +props.rule.args?.direct;
                const app_promotion = +props.rule.args?.app_promotion;
                let unique_emails_label = null;
                let direct_label = null;
                let app_promotion_label = null;
                switch (unique_emails) {
                    case 2: unique_emails_label = 'Non-unique only'; break;
                    case 1: unique_emails_label = 'Unique only'; break;
                    default: unique_emails_label = null;
                }
                switch (direct) {
                    case 2: direct_label = 'Non-direct only'; break;
                    case 1: direct_label = 'Direct only'; break;
                    default: direct_label = null;
                }
                switch (app_promotion) {
                    case 2: app_promotion_label = 'App promo prohibited'; break;
                    case 1: app_promotion_label = 'App promo allowed'; break;
                    default: app_promotion_label = null;
                }
                sublabel = [ota_label, unique_emails_label, direct_label, app_promotion_label].filter(x => x !== null).join(' | ');
                break;
            case TOUR_PARTICIPANT_IS_UPDATED_VIA:
                break;
            case TOUR_PARTICIPANT_SURVEY_STATE:
                break;
            case TOUR_PARTICIPANT_IS_FIELD_AFFECTED:
                break;
            case TOUR_PARTICIPANT_FIELD_EXISTS:
                break;
            case BOOKING_IS_REBOOKING:
                break;
            case TOUR_PARTICIPANT_HAS_TAG_CATEGORY:
                break;
            case TOUR_PARTICIPANT_HAS_TAG:
                break;
            case TRIP_BEGINS_WITHIN_X_TIME:
                break;
            case REVIEW_IS_POSITIVE_NEGATIVE:
                break;
            case REVIEW_RATING:
                break;
            case USER_ENTERS_LOCATION_RADIUS:
                break;
            case BOOKING_DATETIME_IS_WITHIN_RANGE:
                break;
            case USER_HAS_OTHER_TOURS: {
                const args = props.rule.args || {};
                const time = args.time || {};
                const refs = (args.time_ref && typeof args.time_ref === 'object') ? args.time_ref : {};
                // Non-default reference moments (CP-8264) show as e.g. "past@end".
                const flag = (key) => {
                    if (!time[key]) { return null; }
                    const ref = refs[key];
                    return (typeof ref === 'string' && ref !== 'now') ? `${key}@${ref}` : key;
                };
                const parts = [
                    args.same_departure ? 'same departure' : null,
                    args.same_tour ? 'same tour' : null,
                    flag('future'), flag('active'), flag('past'),
                ].filter(Boolean);
                if (Array.isArray(args.tours) && args.tours.length > 0) {
                    parts.push(args.tours.map((t) => (t && t.name) || `#${(t && t.id) || t}`).join(', '));
                }
                const tagChips = Array.isArray(args.tour_tags?.tags) ? args.tour_tags.tags : [];
                if (tagChips.length > 0) {
                    const mode = args.tour_tags.match_mode === 'or' ? ' | ' : ' & ';
                    parts.push('tagged ' + tagChips.map((c) => {
                        if (c && typeof c === 'object' && 'tag' in c) {
                            const id = (c.tag && typeof c.tag === 'object') ? c.tag.id : c.tag;
                            return `#${id}`;
                        }
                        return c ? `${c.category_code} · ${c.tag_name}` : '?';
                    }).join(mode));
                }
                sublabel = parts.join(' · ') || null;
                break;
            }
            case INCLUDE_RULESET:
                sublabel = <Link href={`/notifications/rulesets/${props.rule.nested_ruleset.id}`} target="_blank">{props.rule.nested_ruleset.name}</Link>;
                break;
            case EVENT_TYPE:
                sublabel = <>{(props.rule.args?.events || []).map(x => (<Typography>{x.label}</Typography>))}</>;
                break
            case DATETIME_WITHIN_RANGE:
            case DATE_WITHIN_RANGE:
            case TIME_WITHIN_RANGE: {
                const cmp = DT_RANGE_COMPARISONS.find((c) => c.value === props.rule.args?.comparison);
                const cmpLabel = cmp ? cmp.label : (props.rule.args?.comparison || '?');
                const isBetween = (props.rule.args?.comparison || '').endsWith('_between');
                const rng = isBetween
                    ? `${props.rule.args?.from || '?'} … ${props.rule.args?.to || '?'}`
                    : `${props.rule.args?.from || '?'}`;
                const tz = effectiveTz(props.rule.tpl, props.rule.args?.tz) === TZ_UTC ? 'UTC' : 'tour local';
                sublabel = `${props.rule.args?.input || '?'} ${cmpLabel} ${rng} (${tz})`;
                break;
            }
            default: break;
        }
    }
    return <>{sublabel}</>;
}

export default NotificationRuleDescription;
